import { post } from '@webapp-next/lib/request/webapp/http';

interface Search {
  everything?: {
    field: string;
    type: string;
    data: number | string;
  };
  [key: string]: any;
}

interface Sort {
  [key: string]: string;
}

interface QueryOptions {
  max?: number;
  sort?: Sort;
}

interface ResourceQueryParams {
  search?: Search;
  join?: any[];
  assoc?: any[];
  group?: any[];
  aggr?: any;
}

const defaultSearch = {
  everything: {
    field: 'Id',
    type: 'gt',
    data: 0,
  },
};

export async function resourceQuery(
  system: string,
  {
    search = defaultSearch,
    join = [],
    assoc = [],
    group = [],
    aggr = {},
  }: ResourceQueryParams = {},
  { max = 500, sort = { Id: 'desc' } }: QueryOptions = {}
): Promise<any[]> {
  const body = {
    max,
    sort: sort,
    search,
    join,
    assoc,
    group,
    aggr,
  };

  const query = async (offset = 0): Promise<any[]> => {
    const results: any = (
      await post(
        `api/v1/resource/${system}/QUERY`,
        { ...body, start: offset },
        {}
      )
    ).data;
    if (results.length < max) {
      return results;
    } else {
      const nextResults = await query(offset + max);
      return [...results, ...nextResults];
    }
  };

  return await query();
}
